import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import cardLogoAmericanExpress from '../../../images/card-logo-americanexpress.png';
import cardLogoDiscover from '../../../images/card-logo-discover.png';
import cardLogoGeneric from '../../../images/card-logo-generic.png';
import cardLogoMasterCard from '../../../images/card-logo-mastercard.png';
import cardLogoVisa from '../../../images/card-logo-visa.png';

export const formatCreditCard = number => `**** **** **** ${number}`;

const CardNumber = ({ children, ...props }) => <span {...props}>{formatCreditCard(children)}</span>;
CardNumber.propTypes = { children: PropTypes.string.isRequired };

const cardBrandsImage = {
  'American Express': cardLogoAmericanExpress,
  Discover: cardLogoDiscover,
  MasterCard: cardLogoMasterCard,
  Visa: cardLogoVisa,
};

const CardBrand = ({ children, ...props }) => (
  <img src={cardBrandsImage[children] || cardLogoGeneric} alt="card logo" width="26" height="26" {...props} />
);
CardBrand.propTypes = { children: PropTypes.string.isRequired };

const CreditCard = ({ children, className, size, ...props }) => (
  <div className={classnames('o-flexbox', className)} {...props}>
    <div className="o-flexbox__item">
      <CardBrand>{children.brand}</CardBrand>
    </div>
    <div className="o-flexbox__item u-flex-1 u-text-center">
      <CardNumber
        className={classnames('u-pl-', {
          delta: size === 'medium',
          epsilon: size === 'small',
        })}
      >
        {children.last4}
      </CardNumber>
    </div>
  </div>
);
CreditCard.propTypes = {
  children: PropTypes.shape({
    last4: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['medium', 'small']),
};
CreditCard.defaultProps = {
  className: '',
  size: 'medium',
};

export default CreditCard;
